export default __webpack_public_path__ + "static/feature-banner-spontaneous-4e52c664b202792cb05d501fae76aa6f.jpg";